import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12240_339709)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.59 3.78051L12 2.37891L21 11.3253L16.17 11.3253L4 11.3253L4 9.33721L16.17 9.33721L10.59 3.78051Z"
        fill="#5C0FD9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.41 20.8601L13 22.2617L4 13.3153L8.83 13.3153L21 13.3153L21 15.3034L8.83 15.3034L14.41 20.8601Z"
        fill="#5C0FD9"
      />
    </g>
    <defs>
      <clipPath id="clip0_12240_339709">
        <rect
          width="24"
          height="23.857"
          fill="white"
          transform="translate(0 0.390625)"
        />
      </clipPath>
    </defs>
  </svg>
}

export default SvgComponent;
